import { BrainFunctionEvaluationRating } from '@shared/constants/assessments';
import { BrainFunctionEvaluation } from '@shared/stores/AssessmentEvaluationOverview';

export const isNotEmptyEvaluation = (evaluation?: BrainFunctionEvaluation): boolean => {
  return Boolean(
    evaluation?.evaluationRating &&
    evaluation.evaluationRating !== BrainFunctionEvaluationRating.NGA,
  );
};
